import { AWS_API_URL } from 'global/environment';
import { authorize, getRequest } from 'utils/http';

const backendURL = `${AWS_API_URL}`;

// relevant for apartment resource only
export async function getNonBookableLaundrySlots(resourceId) {
  const url = `${backendURL}/resources/${resourceId}/bookings`;

  return getRequest(url, await authorize());
}
